/*
{
  url: string -- 이동하려는 주소('/project/1') 또는 라우터 이름({name:'', params:{id:1}})
}
*/
export default [
  {
    url: {name: 'project-home', params:{proj_id: 1}},
    name: '총괄관리',
    icon: 'AlertTriangleIcon',
    activeCode: '',
    project_type: '총괄관리',
  },
  {
    url: {name: 'project-home', params:{proj_id: 2}},
    name: '내부종사자 분야',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '내부종사자',
  },
  {
    url: {name: 'project-home', params:{proj_id: 3}},
    name: '도급·용역·위탁사업 분야',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '도급',
  },
  {
    url: {name: 'project-home', params:{proj_id: 4}},
    name: '발주사업 분야',
    icon: 'UsersIcon',
    activeCode: '',
    project_type: '발주',
  },
  {
    url: {name: 'project-home', params:{proj_id: 5}},
    name: '중대시민재해 분야',
    icon: 'ShieldIcon',
    activeCode: '',
    project_type: '중대시민재해',
  }
]
